import { X } from 'lucide-react';
import React from 'react';
import { Badge } from '@components/ui/badge';
import { Calendar } from '@components/ui/calendar';
import { Card, CardContent } from '@components/ui/card';

interface DaySelectorProps {
    selectedDates: Date[];
    onDatesChange: (dates: Date[]) => void;
}

const formatDate = (date: Date) =>
    date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });

export function DaySelector({
    selectedDates,
    onDatesChange
}: DaySelectorProps) {
    return (
        <Card>
            <CardContent className="flex flex-wrap gap-8">
                <Calendar
                    mode="multiple"
                    selected={selectedDates}
                    onSelect={(dates) => onDatesChange(dates ?? [])}
                />

                <div className="flex min-w-[200px] flex-1 flex-col gap-2">
                    <h4 className="text-base font-semibold">Selected Days</h4>
                    {selectedDates.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                            {selectedDates.map((date) => (
                                <Badge
                                    key={date.toISOString()}
                                    variant="info"
                                    className="gap-1"
                                >
                                    {formatDate(date)}
                                    <button
                                        type="button"
                                        aria-label={`Remove ${formatDate(date)}`}
                                        onClick={() =>
                                            onDatesChange(
                                                selectedDates.filter(
                                                    (d) =>
                                                        d.getTime() !==
                                                        date.getTime()
                                                )
                                            )
                                        }
                                        className="hover:text-foreground"
                                    >
                                        <X className="size-3" />
                                    </button>
                                </Badge>
                            ))}
                        </div>
                    ) : (
                        <p className="text-sm text-muted-foreground">
                            Click on days in the calendar to select them for
                            analysis
                        </p>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}
